export const APP_NAME = 'Fleet Assistant';

export const ONBOARDING_THREAD_ID = 'onboarding-thread';

// INFO: Input wrapper max width(example questions link + input + send button)
export const COMPOSER_MAX_WIDTH = '920px';

// INFO: Greeting text max width, after this it should wrap the text
export const GREETING_MAX_WIDTH = '832px';

// INFO: The spacing between the example question panel and the composer(input wrapper)
export const QUESTION_PANEL_GAP = '14px';

// INFO: The question panel height, blocked so that it doesnt change when no results for a search is found
export const QUESTION_PANEL_BLOCK_HEIGHT = 'clamp(200px, min(32vh, 100dvh - 460px), 340px)';

// INFO: Maximum width to assume the question panel renders for modbile devices(vertical example question category filters)
export const SMALL_SCREEN_QUERY = '(max-width: 47.5rem)';

// INFO: The question panel height, blocked so that it doesnt change when no results for a search is found. This is the small screen equivalent
export const QUESTION_PANEL_BLOCK_HEIGHT_STACKED = 'clamp(280px, min(46vh, 100dvh - 460px), 420px)';

// INFO: Consumed in @media by (keep in sync when adding a site)
export const CENTRED_LAYOUT_QUERY = '(min-height: 670px)';

// INFO: Consumed in @media by (keep in sync when adding a site):
export const DOWNWARD_PANEL_QUERY = '(min-height: 650px), (min-height: 570px) and (min-width: 47.5625rem)';

// INFO: Layout transition time from empty state to ongoing conversation and vice-versa
export const LAYOUT_TRANSITION = '300ms';

export enum EOrientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

// INFO: The hosts whose /docs/ links are sources, besides the app's own origin.
// This is hardcoded rather than read from VITE_DOCS_URI because the onboarding content cites the production host in
// every environment, and on localhost real answers cite the staging host. Both are loaded from the app's own origin.
export const DOCUMENT_HOSTS: readonly string[] = ['fleetassistant.rio.cloud', 'fleetassistant-staging.rio.cloud'];

// INFO: The element id of the viewer panel. Sources point their `aria-controls` at it, and the viewer's own focus handling looks itself up by it.
export const DOCUMENT_VIEWER_ELEMENT_ID = 'document-viewer';

// INFO: The category rail on the left of the application layout, which is present at every width.
export const NAVIGATION_RAIL_WIDTH = 50;

// INFO: The limit to which the the conversation section must never
// drop below while the viewer is visible independent of the widths of the chat history or the viewer itself.
export const CONVERSATION_MIN_WIDTH = 480;

// INFO: The share of the space beside the viewer that the conversation keeps on wide screens, so the
// document viewer's maximum width scales with the screen. It takes over from the pixel floor above 1200 px of space.
export const CONVERSATION_MIN_SHARE = 0.4;

// INFO: The narrowest the viewer is worth showing side by side. Once it no longer fits next to the conversation,
// the panel opened last wins: opening the history closes the viewer, and opening a document collapses the history.
export const DOCUMENT_VIEWER_MIN_WIDTH = 360;

// INFO: Below this viewport width a Source keeps today's new-tab behaviour and the viewer is never. It is read at the moment of the click, not from a media query.
export const DOCUMENT_VIEWER_MIN_VIEWPORT_WIDTH =
  NAVIGATION_RAIL_WIDTH + CONVERSATION_MIN_WIDTH + DOCUMENT_VIEWER_MIN_WIDTH;
